export const manifest = {
  screens: {
    scr_0ymf7b: { name: "Investor Deck · Slide 1 Cover", route: "/", position: {"x":160,"y":6160} },
    scr_hlkv5v: { name: "Investor Deck · Slide 2 Problem", route: "/deck/2", position: {"x":1560,"y":6160} },
    scr_wbfhxm: { name: "Investor Deck · Slide 3 Solution", route: "/deck/3", position: {"x":2960,"y":6160} },
    scr_m9ct9q: { name: "Investor Deck · Slide 4 Product", route: "/deck/4", position: {"x":4360,"y":6160} },
    scr_q1mjnx: { name: "Investor Deck · Slide 5 Caller Experience", route: "/deck/5", position: {"x":5760,"y":6160} },
    scr_88eulx: { name: "Investor Deck · Slide 6 Emergency", route: "/deck/6", position: {"x":7160,"y":6160} },
    scr_xymmaw: { name: "Choose a number", route: "/forwardingSetup", position: {"x":160,"y":220} },
    scr_o5heaf: { name: "Set up landline forwarding", route: "/forwardingSetup", state: {"selection":"landline"}, position: {"x":1560,"y":220} },
    scr_8aa3gl: { name: "Turn off landline forwarding", route: "/iosDeactivation", state: {"forwardingNumberType":"landline"}, position: {"x":160,"y":2200} },
    scr_00p3sl: { name: "Choose a plan", route: "/planSelection", state: {"selectedPlanId":"starter"}, position: {"x":160,"y":4180} },
    scr_s9nmtu: { name: "Review consent · Trial offer", route: "/subscriptionConsent", state: {"selectedPlanId":"growth","hasTrialOffer":true}, position: {"x":1560,"y":4180} },
    scr_pnbmnu: { name: "Enter payment details · Trial offer", route: "/proCheckout", state: {"selectedPlanId":"scale","hasTrialOffer":true}, position: {"x":2960,"y":4180} },
    scr_7kg3bq: { name: "Review consent · No trial", route: "/subscriptionConsent", state: {"selectedPlanId":"growth","hasTrialOffer":false}, position: {"x":4360,"y":4180} },
    scr_d3jj3l: { name: "Enter payment details · No trial", route: "/proCheckout", state: {"selectedPlanId":"scale","hasTrialOffer":false}, position: {"x":5760,"y":4180} },
  },
  sections: {
    sec_z4jcuz: { name: "Landline forwarding setup", x: 0, y: 0, width: 2920, height: 1180 },
    sec_5vb9lw: { name: "Landline forwarding deactivation", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_0yf0ak: { name: "Subscription checkout", x: 0, y: 3960, width: 7120, height: 1180 },
    sec_h21qch: { name: "Investor Deck", x: 0, y: 5940, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_z4jcuz", children: [
      { kind: "screen", id: "scr_xymmaw" },
      { kind: "screen", id: "scr_o5heaf" },
    ] },
    { kind: "section", id: "sec_5vb9lw", children: [
      { kind: "screen", id: "scr_8aa3gl" },
    ] },
    { kind: "section", id: "sec_0yf0ak", children: [
      { kind: "screen", id: "scr_00p3sl" },
      { kind: "screen", id: "scr_s9nmtu" },
      { kind: "screen", id: "scr_pnbmnu" },
      { kind: "screen", id: "scr_7kg3bq" },
      { kind: "screen", id: "scr_d3jj3l" },
    ] },
    { kind: "section", id: "sec_h21qch", children: [
      { kind: "screen", id: "scr_0ymf7b" },
      { kind: "screen", id: "scr_hlkv5v" },
      { kind: "screen", id: "scr_wbfhxm" },
      { kind: "screen", id: "scr_m9ct9q" },
      { kind: "screen", id: "scr_q1mjnx" },
      { kind: "screen", id: "scr_88eulx" },
    ] },
  ],
}
